import girderRest from 'platform/web-girder/plugins/girder';
function getBrandData() {
    return girderRest.get('dive_configuration/brand_data');
}
function putBrandData(brandData) {
    return girderRest.put('dive_configuration/brand_data', brandData);
}
function getTranscodingConfig() {
    return girderRest.get('dive_configuration/transcode_config');
}
function putTranscodingConfig(transcodingConfig) {
    return girderRest.put('dive_configuration/transcode_config', transcodingConfig);
}
function getSampledataConfig() {
    return girderRest.get('dive_configuration/sampledata_config');
}
function putSampledataConfig(sampldataConfig) {
    return girderRest.put('dive_configuration/sampledata_config', sampldataConfig);
}
function getDIVEGirderConfig() {
    return girderRest.get('dive_configuration/dive_girder_config');
}
function putDIVEGirderConfig(diveGirderConfig) {
    return girderRest.put('dive_configuration/dive_girder_config', diveGirderConfig);
}
export { getBrandData, putBrandData, getTranscodingConfig, putTranscodingConfig, getSampledataConfig, putSampledataConfig, getDIVEGirderConfig, putDIVEGirderConfig, };
